import { Tab } from "@mui/icons-material";

export const OngletItemConfig = {
    type: 20,
    label: 'Onglet',
    icon: Tab,
    allowedBy: [19],
    autoConfig: false,
}